<template>
  <div class="">
    <v-container fluid>
      <v-row align-content="center">
        <v-col cols="12">
          <tradeCharts />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import tradeCharts from "@/components/Market/exchange/tradeCharts/index.vue";
import { MarketMarketService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "index",
  components: { tradeCharts },
  mounted() {
    if (!this.$route.params.pair) {
      this.$router.push({
        path: `/m-exchange/USDT_IRR`
      });
    }
    localStorage.setItem("isAuth", "true");
    this.getSymbol();
  },

  methods: {
    ...mapActions({
      setCurrentCoin: types.marketExchange.actions.SET_CURRENT_COIN
    }),
    getSymbol() {
      MarketMarketService.getSymbolsThumbBase(
        this.$route.params.pair.split("_")[1]
      ).then(response => {
        this.items = response.data;
        if (this.$route.params.pair) {
          let currentItem = this.items.find(
            obj => obj.symbol === this.$route.params.pair.replace("_", "/")
          );
          if (currentItem) {
            this.setCurrentCoin(currentItem);
          }
        }
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
